export enum BranchLocalStorage {
  KEY = 'branchFilterKey',
  TYPE = 'branchFilterType',
  START_DATE = 'branchFilterStartDate',
  END_DATE = 'branchFilterEndDate',
  IS_WHITE_MARK = 'branchFilterIsWhiteMark',
  DISTRIBUTOR_ID = 'branchFilterDistributorId',
  GROUP_ID = 'branchFilterGroupId',
  COMPANY_ID = 'branchFilterCompanyId',
}
